<template>
  <div>
    <b-table small outlined :items="$store.state.event.resultats_equipes" :fields="fields_equipe" sort-by="classement"
      responsive id="table_equipe" thead-class="head_equipes">
      <!-- TEMPLATE ROW CLASSEMENT -->
      <template slot="classement" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0; margin-left: 10px">
          Clt : {{ data.item.classement
          }}<span v-if="data.item.classement === 1">er</span><span v-else>ème</span>
        </p>
      </template>
      <template slot="classement_sexe" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0; margin-left: 10px">
          Clt sexe : {{ data.item.classement_sexe
          }}<span v-if="data.item.classement_sexe === 1">er</span><span v-else>ème</span> {{ data.item.sexe }}
        </p>
      </template>
      <!-- TEMPLATE ROW EQUIPE -->
      <template slot="nom_equipe" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">
          Equipe {{ data.item.nom_equipe }}
        </p>
      </template>
      <!-- TEMPLATE ROW TEMPS -->
      <template slot="temps" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">
          Temps : {{ data.item.temps }}
        </p>
      </template>
      <!-- TEMPLATE ROW MOYENNE -->
      <template slot="moy" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">
          Moyenne : {{ data.item.moy }}km/h
        </p>
      </template>
      <template #row-details="row">
        <b-card class="inner_equipe_classement">
          <b-table small outlined striped :items="row.item.coureurs" :fields="fields" @row-clicked="openModal"
            sort-by="Clt" responsive tbody-tr-class="row_coureur_equipe" class="table_coureur_equipe">
            <!-- TEMPLATE ROW NATION -->
            <template slot="Nat" slot-scope="data">
              <img :src="'https://sportips.fr/live/img/Flags/' +
                data.item.nation +
                '.jpg'
                " />
            </template>


            <!-- TEMPLATE ROW AVEC COULEURS -->
            <template v-for="(colored_field, index) in colored_fields" :slot="colored_field" slot-scope="data">
              <span v-if="data.item.sexe === 'F'" style="color: #800080; font-weight: bold" :key="index">{{
                data.item[colored_field] }}
              </span>
              <span v-if="data.item.sexe === 'M'" style="color: #000080; font-weight: bold" :key="index">{{
                data.item[colored_field] }}
              </span>
              <span v-if="data.item.sexe === 'X'" style="color: #215b0c; font-weight: bold" :key="index">{{
                data.item[colored_field] }}
              </span>
            </template>

            <!-- TEMPLATE ROW INFOS -->
            <template slot="Plus" slot-scope="data">
              <b-button size="sm" @click="openModal(data.item, 0)" class="btn-informations py-0">
                <v-icon name="info" style="font-size: 10px" />
              </b-button>
              <b-button size="sm" class="diploma-dl-btn py-0" @click="downloadDiploma(data.item)">
                <img src="https://sportips.fr/plateformeResultats/assets/school.svg" class="diploma-icon"
                  style="height: 10px; fill: white" />
              </b-button>
            </template>
            <!-- TEMPLATE ROW TEMPS -->
            <template slot="Temps" slot-scope="data">
              <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>

    <b-modal v-model="show_modal" ref="modal_coureur" size="xl" :title="'Fiche coureur : ' + selectedCoureur.nom + ' ' + selectedCoureur.prenom
      " hide-footer>
      <ModalCoureur :coureur="selectedCoureur" :diplome="diplome" :nom_epreuve="nom_epreuve"></ModalCoureur>
    </b-modal>
  </div>
</template>

<script>
import ModalCoureur from "@/component/Epreuve/ModalCoureur";
export default {
  components: { ModalCoureur },

  data() {
    return {
      selectedCoureur: {},
      show_modal: false,
      fields_equipe: [
        { key: "classement", label: "Clt", sortable: false, tdClass: "" },
        { key: "classement_sexe", label: "Clt sexe", sortable: false, tdClass: "" },
        { key: "nom_equipe", label: "Nom", sortable: false, tdClass: "" },
        { key: "temps", label: "Temps", sortable: false, tdClass: "" },
        { key: "moy", label: "Moyenne", sortable: false, tdClass: "" },
      ],
    };
  },
  computed: {
    fields() {
      return this.$store.state.event.data.fields;
    },
    colored_fields() {
      return this.$store.state.event.data.colored_fields;
    },
    diplome() {
      return this.$store.state.event.data.diplome;
    },
    nom_epreuve() {
      return this.$store.state.event.data.nom_epreuve;
    },
  },
  methods: {
    openModal(data, index) {
      const nb_coureur_in_cat = this.$store.getters['event/getNbCoureurInCat'](data);
      const nb_coureur_in_sexe = this.$store.getters['event/getNbCoureurInSexe'](data);

      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = nb_coureur_in_cat;
      this.selectedCoureur.nb_coureur_in_sexe = nb_coureur_in_sexe;
      this.show_modal = true;
      /* this.$refs["modal_coureur"].show(); */
    },


    downloadDiploma(data) {
      const nb_coureur_in_cat = this.$store.getters['event/getNbCoureurInCat'](data);
      const nb_coureur_in_sexe = this.$store.getters['event/getNbCoureurInSexe'](data);

      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = nb_coureur_in_cat;
      this.selectedCoureur.nb_coureur_in_sexe = nb_coureur_in_sexe;
      if (this.diplome != 0) {
        let routeData = this.$router.resolve({
          name: "GetDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "GetGDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
  async created() {
    await this.$store.dispatch("event/buildResultatsEquipes");

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/component/Epreuve/TableauResultatsEquipe.vue